import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CostAccountingDialogModule } from './cost-accounting-dialog/cost-accounting-dialog.module';
import { GenericDateInputModule, GenericInputModule } from '@sla-ng/ui-material';
import { CostAccountingPage } from './cost-accounting-page';

export * from './cost-accounting-page';
export * from './cost-accounting-dialog/cost-accounting-dialog.module';

const routes: Routes = [
    {
        path: '',
        component: CostAccountingPage,
    },
];

@NgModule({
    providers: [
        DatePipe,
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
    ],
    declarations: [
        CostAccountingPage,
    ],
    imports: [
        CostAccountingDialogModule,
        CommonModule,
        RouterModule.forChild(routes),
        MatProgressBarModule,
        MatTableModule,
        TranslateModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatChipsModule,
        FormsModule,
        MatSortModule,
        MatMomentDateModule,
        MatFormFieldModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        MatDividerModule,
        GenericInputModule,
        MatSelectModule,
        MatPaginatorModule,
        GenericDateInputModule,
        MatTooltipModule,
        MatInputModule,
        MatSliderModule,
    ],
    exports:[ RouterModule ]
})
export class CostAccountingPageModule {}
